/**
 * Lightweight image helpers — keep free of heavy @/utils barrel deps
 * (ripple-address-codec, platform, currencies.json, etc.).
 */

export const getAvifImagePath = (image) => {
  return image.replace(/\.(png|jpg|jpeg)/i, '.avif');
};

export const getFallbackImage = (type) => {
  let fallbackImage = `https://assets.bidali.com/commerce/placeholders/phone.png`;
  switch (type) {
    case 'digitaltv':
      fallbackImage = `https://assets.bidali.com/commerce/placeholders/digitaltv.png`;
      break;
    case 'giftcard':
      fallbackImage = `https://assets.bidali.com/commerce/placeholders/giftcard.png`;
      break;
  }
  return fallbackImage;
};
